<template>
  <el-table :data="tableServerInfo" border>
    <el-table-column prop="ids" label="序号" align="center" width="60px"></el-table-column>
    <el-table-column prop="orderNum" label="订单号" align="center"></el-table-column>
    <el-table-column prop="iccid" label="ICCID" align="center"></el-table-column>
    <el-table-column prop="payType" label="消费类型" align="center">
      <template slot-scope="{row}">
        <span v-if="row.payType == '1'">收入</span>
        <span v-else>支出</span>
      </template>
    </el-table-column>
    <el-table-column prop="source" label="积分类型" align="center"></el-table-column>
    <el-table-column prop="integral" label="积分明细" align="center">
      <template slot-scope="{row}">
        <span v-if="row.payType == '1'" style="color:#ff4949"> +{{row.integral}}</span>
        <span v-else style="color:#13ce66;">{{row.integral}}</span>
      </template>
    </el-table-column>
    <el-table-column prop="payTime" label="更新时间" align="center"></el-table-column>
    <el-table-column prop="remark" label="备注" align="center"></el-table-column>
  </el-table>
</template>
<script>
import { cardIntegralRecord } from "@/api/api.js";
export default {
  props: {
    iccid: {
      type: [String]
    }
  },
  data() {
    return{
      tableServerInfo:[],
    }
  },
  watch: {
    iccid() {
      this.initData();
    }
  },
  methods: {
    // 支付方式
    transferPayType(status){
      let obj = {
        1: "H5支付",
        2: "微信支付",
        3: "余额支付",
        4: "系统支付",
        5: "支付宝支付",
        6: "积分支付",
      };
      return obj[status];
    },
    // 积分来源
    IntegralSource(status){
      let obj = {
        1: "用户批量充值",
        2: "卡充值",
        3: "卡积分兑换",
        4: "账户积分兑换",
        5: "卡绑定",
        6: "卡解绑",
        7: "用户批量充值退款",
        8: "退款扣卡积分 ",
        9: "退款扣用户积分",
      };
      return obj[status];
    },
    // 获取列表的数据
    initData(){
      let params = {
        iccid:this.iccid
      };
      cardIntegralRecord(params).then(res => {
        if(res.data.code == 200){
          this.tableServerInfo = res.data.data;
          this.tableServerInfo.map((item,index)=>{
            item.ids = index + 1;
            // item.payType = this.transferPayType(item.payType);
            item.source = this.IntegralSource(item.source);
          })
        }
      })
    },
  },
  created() {}
};
</script>

<style scoped lang="less">

</style>


